import { Phone } from "lucide-react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

const NUMBER = "(888) 550-9339";

/**
 * Click-to-call badge — ONLY renders on the index (landing) page.
 * Uses `tel:` for native dialer on mobile; fires non-blocking analytics to /api/calls/track.
 */
export default function CallBadge() {
  const { pathname } = useLocation();
  if (pathname !== "/") return null;

  const onClick = () => {
    try {
      api.post("/calls/track", {
        page: typeof window !== "undefined" ? window.location.pathname + window.location.search : "",
        number: NUMBER,
      }).catch((error) => console.warn("Call tracking failed (non-blocking)", error));
    } catch (error) {
      console.warn("Call tracking failed (non-blocking)", error);
    }
  };
  return (
    <a
      href="tel:+18885509339"
      onClick={onClick}
      data-testid="global-call-badge"
      aria-label="Call RealtyVault Manager support toll free at (888) 550-9339"
      className="group fixed bottom-4 right-4 md:bottom-auto md:top-20 z-[9998] inline-flex items-center gap-2 rounded-full bg-slate-900 text-white pl-3 pr-4 py-2 text-sm font-semibold shadow-[0_12px_40px_-10px_rgba(0,0,0,0.6)] border border-white/10 hover:bg-slate-800 hover:border-white/20 transition-all duration-200 hover:-translate-y-0.5 backdrop-blur-sm"
    >
      <span className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center group-hover:bg-emerald-400 transition-colors">
        <Phone className="w-3.5 h-3.5 text-slate-900" fill="currentColor" strokeWidth={2.5} />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[9px] uppercase tracking-widest text-white/50 font-mono">Toll free</span>
        <span className="font-mono tracking-tight">{NUMBER}</span>
      </span>
      <span className="sm:hidden font-mono">Call</span>
    </a>
  );
}
